import React, { Component } from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Grid from '@material-ui/core/Grid'

import { connect } from 'react-redux'
import { loadUserData } from '../../actions'

import { CheckCircleOutline, HighlightOff } from '@material-ui/icons'
import { green, red } from '@material-ui/core/colors'

import Chip from '@material-ui/core/Chip'
import Link from '@material-ui/core/Link'
import MaterialTable from 'material-table'

let selectedOptions = []
let selectedCourses = []

let selectedTerms = []

const styles = makeStyles((theme) => ({
  listItem: {
    padding: theme.spacing(1, 0)
  },
  total: {
    fontWeight: '700'
  },
  title: {
    marginTop: theme.spacing(2)
  }
}))

class Review extends Component {
  selectedUsers = []

  componentDidMount() {
    let userText = this.props.data.summery.userstext.split(',')

    for (let i = 0; i < userText.length; i++) {
      this.props.loadUserData(userText[i], userText.length + 1)
    }
  }

  render() {
    //  function Review(props) {
    // const classes = useStyles();

    const { data, classes } = this.props

    selectedOptions = data.summery.data

    let enrollmentType = selectedOptions.filter(
      (d) => d.title !== 'Programme'
    )[0]

    selectedOptions = data.summery.data.filter((data) => data.value != 'role')

    selectedCourses = data.summery.courses

    selectedTerms = data.selectedTerms.data

    let userText = data.summery.userstext.split(',')

    this.selectedUsers = data.users.data.map((user) =>
      user[0]['login_id'].toLowerCase()
    )

    let finalizeUsers = []

    for (let i = 0; i < userText.length; i++) {
      let exist = false

      if (this.selectedUsers.indexOf(userText[i].toLowerCase()) != -1) {
        exist = true
      }

      finalizeUsers.push({ email: userText[i], exist: exist })
    }

    const headCells = [
      {
        field: 'sis_course_id',
        numeric: true,
        disablePadding: false,
        title: 'Course ID',

        render: (row) => (
          <Link
            href='#'
            onClick={() =>
              window.open(
                process.env.REACT_APP_CANVAS_DOMAIN + 'courses/' + row.id,
                '_blank'
              )
            }
          >
            {row.sis_course_id === null ? row.id : row.sis_course_id}
          </Link>
        )
      },

      {
        field: 'name',
        numeric: false,
        disablePadding: false,
        title: 'Course Name'
      }
    ]

    return (
      <React.Fragment>
        <Typography variant='h6' gutterBottom>
          Summary
        </Typography>
        <List disablePadding>
          {selectedOptions.map((product) => (
            <ListItem key={product.id + product.name}>
              <ListItemText
                primary={
                  product.title === 'Programme'
                    ? 'Programme'
                    : 'Enrollment Type'
                }
                secondary={product.desc}
              />
              <Typography variant='body2'>{product.name}</Typography>
            </ListItem>
          ))}

          <ListItem key='csvactivetype'>
            <ListItemText primary='Action Type' />
            <Typography variant='body2'>
              {data.csvActionType === 'active' ? 'Add Users' : 'Remove Users'}
            </Typography>
          </ListItem>
        </List>

        {/* <Typography variant="h6" gutterBottom>
        Selected Terms
      </Typography>
      <List disablePadding>
        {selectedTerms.map(terms => (
          <ListItem  key={terms.id}>
            <ListItemText primary="Term Name" />
            <Typography variant="body2">{terms.name}</Typography>
          </ListItem>
        ))}
    
      </List> */}

        <Typography variant='h6' gutterBottom>
          Selected Courses
        </Typography>

        {/* <MaterialTable
          title=" Selected Courses"
          columns={headCells}
          data={selectedCourses}
          options={{
            search: false,
            // selection: true,
            // pageSize: 25,
            // emptyRowsWhenPaging: false,
            // pageSizeOptions: PAGE_OPTIONS.split(',')
            // filtering: true
          }}
          // localization={{
          //   body: {
          //     emptyDataSourceMessage: 'Please select programme and correct term.'
          //   }

          // }}
          // onSelectionChange={handleClick}
        /> */}

        <List
          style={{
            position: 'relative',
            overflow: 'auto',
            maxHeight: 300
          }}
          disablePadding
        >
          {selectedCourses.map((course) => (
            <ListItem key={course.sis_course_id}>
              <ListItemText
                primary={
                  <Link
                    underline='always'
                    href='#'
                    onClick={() =>
                      window.open(
                        process.env.REACT_APP_CANVAS_DOMAIN +
                          'courses/' +
                          course.id,
                        '_blank'
                      )
                    }
                  >
                    {course.id}
                  </Link>
                }
              />
              <Typography variant='body2'>{course.name}</Typography>
            </ListItem>
          ))}
        </List>

        <Typography variant='h6' gutterBottom>
          Selected Users
        </Typography>
        <List disablePadding>
          {finalizeUsers.map((user) => (
            <ListItem key={user.email}>
              <ListItemText
                primary={user.email + ' ( ' + enrollmentType.name + ' ) '}
              />

              <Typography variant='body2'>
                {' '}
                {user.exist ? (
                  <CheckCircleOutline style={{ color: green[500] }} />
                ) : (
                  <div>
                    {' '}
                    <Chip label='User Not Found' variant='outlined' />{' '}
                    <HighlightOff style={{ color: red[500] }} />{' '}
                  </div>
                )}{' '}
              </Typography>
            </ListItem>
          ))}
        </List>
        <Grid container spacing={2}></Grid>
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    data: state.CourseLevelAdmin
  }
}

// export default (withStyles(styles)(connect(
//   mapStateToProps,
//   { loadUserData }
// )(Review)));

export default connect(mapStateToProps, { loadUserData })(Review)
